import { TypeMontant } from './TypeMontant';

export class SousTraitanceOui {

  public partPct: number;

  public partValeur: TypeMontant;

  public partInconnue: string;

  constructor() {
    this.partPct = 0;
    this.partValeur = new TypeMontant();
    this.partInconnue = '';

  }
}
